// extracted by mini-css-extract-plugin
export default {"p_content":"ecfc491547"};